import { render, staticRenderFns } from "./ActionNotificationModal.vue?vue&type=template&id=01c01fd4"
import script from "./ActionNotificationModal.vue?vue&type=script&lang=js"
export * from "./ActionNotificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports